export class Course {
    constructor(CourseCode, CourseNameEN, CourseStateID,
       CreditHours , Description , serial ,Serial) {
      this.CourseCode = CourseCode;
      this.CourseNameEN = CourseNameEN;
      this.CourseStateID = CourseStateID;
      this.CreditHours = CreditHours;
      this.Description = Description;
      this.serial = serial ? serial : Serial;
      
    }
  }

  